import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Select, MenuItem } from '@mui/material';

function Layout({ children, customer, langs = [], title = '', size = 'lg' }) {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.title = customer.name + (title ? ` - ${title}` : '');
    }, [customer, title]);

    useEffect(() => {
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    const handleLangChange = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                py: 2,
                mt: 4
            }}>
                {customer && (
                    customer.logo ? (
                        <Box
                            component={customer.url ? "a" : "div"}
                            href={customer.url || undefined}
                            sx={{ textDecoration: 'none' }}
                        >
                            <img
                                src={customer.logo}
                                alt={customer.name}
                                style={{ maxHeight: '120px' }}
                            />
                        </Box>
                    ) : (
                        <Box
                            component="h1"
                            sx={{ m: 0, textDecoration: 'none', color: 'inherit' }}
                        >
                            {customer.url ? (
                                <a href={customer.url} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    {customer.name}
                                </a>
                            ) : (
                                customer.name
                            )}
                        </Box>
                    )
                )}
            </Box>
            <Container component="main" sx={{ flex: 1, py: 4 }} maxWidth={size}>
                {langs.length > 1 && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                        <Select
                            size="small"
                            value={i18n.language}
                            onChange={handleLangChange}
                            variant="standard"
                        >
                            {langs.map((lang) => (
                                <MenuItem key={lang} value={lang}>
                                    {t('languageName', { lng: lang })}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                )}
                {children}
            </Container>
            <Box
                component="footer"
                sx={{
                    py: 3,
                    px: 2,
                    mt: 'auto',
                    textAlign: 'center',
                    color: 'text.secondary'
                }}
            >
                <Typography variant="body2">
                    © {new Date().getFullYear()} {customer?.name}. All rights reserved.
                </Typography>
                {customer?.url && (
                    <Typography
                        variant="body2"
                        component="a"
                        href={customer.url}
                        sx={{
                            color: 'text.secondary',
                            textDecoration: 'none',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {customer.url}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}

export default Layout;
